import { css } from '@emotion/css';

export const picklistStyles = css`
  width: 100%;
  .MuiOutlinedInput-root {
    flex-wrap: nowrap;
  }

  .MuiOutlinedInput-input {
    min-width: unset;
  }
`;
